import { render, staticRenderFns } from "./SpouseDetail.vue?vue&type=template&id=434d671e&scoped=true&"
import script from "./SpouseDetail.vue?vue&type=script&lang=js&"
export * from "./SpouseDetail.vue?vue&type=script&lang=js&"
import style0 from "./SpouseDetail.vue?vue&type=style&index=0&id=434d671e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "434d671e",
  null
  
)

export default component.exports